<script setup>
defineProps({
  as: {
    type: String,
    default: 'div',
  },
});
</script>

<template>
  <component
    :is="as"
    data-testid="page-content-layout"
    class="mx-auto w-full min-w-0 max-w-5xl"
  >
    <slot />
  </component>
</template>
